import { initializeApp } from "firebase/app";
import { enableNetwork, getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

if (!firebaseConfig.projectId) {
  throw new Error("Missing Firebase config. Check env vars.");
}

export const app = initializeApp(firebaseConfig);

// Real default DB
export const db = getFirestore(app);

// Named greens DB
export const greensDb = getFirestore(app, "greenlayouts");

(async () => {
  try {
    await enableNetwork(db);
    await enableNetwork(greensDb);
    console.log("[SS][FIRESTORE] enableNetwork: OK");
  } catch (e) {
    console.warn("[SS][FIRESTORE] enableNetwork failed", e);
  }
})();